var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-button',_vm._g(_vm._b({staticClass:"btt-popup-footer-button k-pa-x-xl k-pa-y-md"},'k-button',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"k-text-subtitle"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }